import React from 'react';
import { Mui, MuiIcons } from '@osu/react-ui';

/**
 * ErrorBoundary Component
 * Catches JavaScript errors anywhere in the child component tree
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Mui.Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
          <MuiIcons.ErrorOutline sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
          <Mui.Typography variant="h4" component="h1" gutterBottom color="error">
            Something went wrong
          </Mui.Typography>
          <Mui.Typography variant="body1" color="text.secondary" paragraph>
            We're sorry, but something unexpected happened. Please try refreshing the page.
          </Mui.Typography>
          
          <Mui.Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Mui.Button 
              variant="contained" 
              onClick={() => window.location.reload()}
              startIcon={<MuiIcons.Refresh />}
            >
              Reload Page
            </Mui.Button>
            <Mui.Button 
              variant="outlined" 
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
            >
              Try Again
            </Mui.Button>
          </Mui.Box>


        </Mui.Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;